import React, { useState } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import PilotDashboard from './components/PilotDashboard';
import PilotPortal from './components/PilotPortal';

// Determine API base URL based on environment
const isCapacitor = typeof window.Capacitor !== 'undefined';

let API_BASE_URL;
if (isCapacitor) {
  API_BASE_URL = 'http://127.0.0.1:8001';
} else {
  // Use environment variable from .env file
  API_BASE_URL = process.env.REACT_APP_API_BASE || 'http://localhost:8001';
}

/**
 * Root wrapper component that handles pilot vs customer mode routing
 * This component has minimal hooks and routes to the appropriate app
 */
function RootApp() {
  // Check URL parameters for pilot mode
  const urlParams = new URLSearchParams(window.location.search);
  const isPilotMode = urlParams.get('mode') === 'pilot' || window.location.pathname.includes('/pilot');
  
  // Pilot authentication state
  const [pilotToken, setPilotToken] = useState(localStorage.getItem('pilotToken'));
  const [pilotUser, setPilotUser] = useState(() => {
    const stored = localStorage.getItem('pilotUser');
    return stored ? JSON.parse(stored) : null;
  });

  // Handle pilot login
  const handlePilotLoggedIn = (token, user) => {
    localStorage.setItem('pilotToken', token);
    localStorage.setItem('pilotUser', JSON.stringify(user));
    setPilotToken(token);
    setPilotUser(user);
  };

  // Handle pilot logout
  const handlePilotLogout = () => {
    localStorage.removeItem('pilotToken');
    localStorage.removeItem('pilotUser');
    setPilotToken(null);
    setPilotUser(null);
    window.location.href = '/?mode=pilot';
  };

  // Pilot mode: Show dashboard if logged in, otherwise show portal
  if (isPilotMode) {
    if (pilotToken && pilotUser) {
      return (
        <PilotDashboard
          apiBaseUrl={API_BASE_URL}
          token={pilotToken}
          user={pilotUser}
          onLogout={handlePilotLogout}
        />
      );
    }
    return (
      <PilotPortal
        apiBaseUrl={API_BASE_URL}
        onPilotLoggedIn={handlePilotLoggedIn}
      />
    );
  }

  // Customer mode: Show normal app
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>
);
